import { render, staticRenderFns } from "./CustomBoxItem.vue?vue&type=template&id=16121b68&"
import script from "./CustomBoxItem.vue?vue&type=script&lang=js&"
export * from "./CustomBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports